const books = {
  books: [],
  loading: false,
  error: null,
};

export default books;
